import React, { useState, useEffect } from "react";
// componentes
import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
  Row,
} from "reactstrap";
import ModalNewNotification from "./ModalNewNotification";
import ModalEdidNotification from "./ModalEditNotification";
import ModalNewNotificationPublic from "./ModalNewNotificationPublic";
import ModalViewNotificationPrivate from "./ModalViewNotificationPrivate";
import ModalNotificationRecipients from "./ModalNotificationRecipients";
import ModalAllImports from "./ModalAllImports";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import SearchFilters from "../../../components/SearchFilters";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
import Pagination from "../../../components/Paginationv3";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// redux
import { connect } from "react-redux";
// rotas
import { useLocation } from "react-router-dom";
// service
import {
  getNotification,
  deleteNotification,
  getNotificationPublic,
} from "../../../utils/services/notification";
import { getMobileApps } from "../../../utils/services/mobileApps";
// utils
import useDebounce from "../../../utils/hooks/useDebounce";

function Notification(props) {
  const location = useLocation();
  //pesquisa
  const [search, setSearch] = useState("");
  //modais
  const [modalNewNotification, setModalNewNotification] = useState(false);
  const [modalNewNotificationPublic, setModalNewNotificationPublic] =
    useState(false);
  const [modalEditNotification, setModalEditNotification] = useState(false);
  const [modalViewNotificationPrivate, setModalViewNotificationPrivate] =
    useState(false);
  const [modalAllImports, setModalAllImports] = useState(false);
  // selecionado para visualizar
  const [selectedToView, setSelectedToView] = useState(null);
  // destinatarios da notificacao
  const [modalRecipients, setModalRecipients] = useState(false);
  const [selectedToRecipients, setSelectedToRecipients] = useState(null);
  //deletar notificação
  const [notificationDelete, setNotificationDelete] = useState();
  const [confirmAlert, setConfirmAlert] = useState(false);
  const [successDlg, setSuccessDlg] = useState(false);
  const [dynamicTitle, setDynamicTitle] = useState("");
  const [dynamicDescription, setDynamicDescription] = useState("");
  const [errorOnDelete, setErrorOnDelete] = useState(false);
  //editar notificação
  const [editNotification, setEditNotification] = useState();
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  //state das notificações
  const [notification, setNotification] = useState([]);
  const [notificationPublic, setNotificationPublic] = useState([]);
  //estado com a quantidade total de items na API
  const [countData, setCountData] = useState(1);
  const [countDataPublic, setCountDataPublic] = useState(1);

  const [itemsPerPage, setItemsPerPage] = useState(10);
  // id do evento
  const idEvent = location.state.idEvent;
  const eventName = location.state.event.title;
  // collapse
  const [isOpen, setIsOpen] = useState(false);

  const debouncedSearch = useDebounce(search, 300);
  const [isPublic, setIsPublic] = useState(false);

  const [mobileapps, setMobileApps] = useState([]);

  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("title");
  // loading
  const [loading, setLoading] = useState(false);

  const columnsFilter = [
    { name: "Título", value: "title", type: "text" },
    { name: "Mensagem", value: "message", type: "text" },
    { name: "Data", value: "date", type: "date" },
  ];

  // atualiza o filtro ativo e limpa a busca
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // inverte a data de dd/mm/yyyy para o formato aceito pela API (yyyy-mm-dd)
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  // aplica o tratamento de busca conforme o tipo da coluna filtrada (data ou texto)
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  // abre/fecha o modal de criar notificação privada
  function toggleNewNotification() {
    setModalNewNotification(!modalNewNotification);
  }

  // abre/fecha o modal de criar notificação pública
  function toggleNewNotificationPublic() {
    setModalNewNotificationPublic(!modalNewNotificationPublic);
  }

  // abre/fecha o modal de editar notificação
  function toggleEditNotification() {
    setModalEditNotification(!modalEditNotification);
  }

  // busca as notificações privadas paginadas
  async function getAllNotification() {
    setLoading(true);
    try {
      const formData = await getNotification({
        jwt: props.state.global_user_data.data.token,
        idEvent: idEvent,
        offset: currentIndex > 0 ? currentIndex : 1,
        limit: itemsPerPage,
        search: treatmentSearch(),
        columnSearch: activeFilter,
      });

      if (formData.message === "NOTIFICATION_FINDED") {
        setNotification(formData.findOneNotificationData.data);
        setCountData(formData.findOneNotificationData.count);
      }
    } catch (error) {
      console.error("Erro ao buscar notificações:", error);
      toast.error("Erro ao buscar notificações.");
    } finally {
      setLoading(false);
    }
  }

  // busca as notificações públicas paginadas
  async function getAllNotificationPublic() {
    setLoading(true);
    try {
      const formData = await getNotificationPublic({
        jwt: props.state.global_user_data.data.token,
        idEvent: idEvent,
        offset: currentIndex > 0 ? currentIndex : 1,
        limit: itemsPerPage,
        search: treatmentSearch(),
        columnSearch: activeFilter,
      });

      if (formData.message === "NOTIFICATION_PUBLIC_FINDED") {
        setNotificationPublic(formData.findOneNotificationData.data);
        setCountDataPublic(formData.findOneNotificationData.count);
      }
    } catch (error) {
      console.error("Erro ao buscar notificações públicas:", error);
      toast.error("Erro ao buscar notificações públicas.");
    } finally {
      setLoading(false);
    }
  }

  // exclui a notificação selecionada
  async function confirmDelete() {
    try {
      const formData = await deleteNotification(
        props.state.global_user_data.data.token,
        notificationDelete.id,
      );

      setConfirmAlert(false);

      if (formData.message === "NOTIFICATION_DISABLED") {
        setDynamicTitle("Sucesso");
        setDynamicDescription("Notificação deletada com sucesso");
        setErrorOnDelete(false);
      } else {
        setDynamicTitle("Erro");
        setDynamicDescription("Erro ao deletar a notificação.");
        setErrorOnDelete(true);
      }
      setSuccessDlg(true);
    } catch (error) {
      console.error("Erro ao deletar a notificação:", error);
      setConfirmAlert(false);
      setDynamicTitle("Erro");
      setDynamicDescription("Erro ao deletar a notificação.");
      setErrorOnDelete(true);
      setSuccessDlg(true);
    }
  }

  // formata a data para dd/mm/yyyy
  function formatData(startDate) {
    var data = new Date(startDate);
    var dia = String(data.getDate()).padStart(2, "0");
    var mes = String(data.getMonth() + 1).padStart(2, "0");
    var ano = data.getFullYear();
    var dataAtual = dia + "/" + mes + "/" + ano;

    return dataAtual;
  }

  // extrai o horário hh:mm de uma data ISO
  function formatHour(startDate) {
    return startDate.split("T")[1].slice(0, 5);
  }

  // busca os apps mobile do contrato, usados para exibir o nome do app pelo bundle id
  async function getMobileAppEvent() {
    try {
      const res = await getMobileApps({
        offset: 1,
        limit: 1000,
        search: "",
        contractId: props.state.global_user_data.data.theme[0]?.id,
        status: "TODOS",
      });

      if (
        res.message === "findAllMobileApp" &&
        res.findAllMobileAppData.count > 0
      ) {
        setMobileApps(res.findAllMobileAppData.data);
      } else setMobileApps([]);
    } catch (error) {
      console.error("Erro ao buscar aplicativos:", error);
      toast.error("Erro ao buscar aplicativos.");
    }
  }

  // resolve o nome do app a partir do bundle id (notificação pública, um app só)
  function getAppName(bundle) {
    if (mobileapps.length < 1) return bundle;

    const search = mobileapps.find((e) => e.bundleId === bundle);

    if (search) {
      return search.name;
    } else return bundle;
  }

  // resolve os nomes dos apps a partir da lista de bundle ids (notificação privada, vários apps)
  function getAppNamePrivate(bundle) {
    if (mobileapps.length < 1) return bundle;

    if (!bundle) return "";

    var bundleString = bundle
      .replaceAll("'", "")
      .replaceAll(" ", "")
      .split(",")
      .map((e) => {
        const search = mobileapps.find((obj) => obj.bundleId === e);

        if (search) {
          return search.name;
        } else return e;
      })
      .join(", ");

    return bundleString;
  }

  useEffect(() => {
    getAllNotification();
    getAllNotificationPublic();
  }, [currentIndex, itemsPerPage, debouncedSearch, isPublic]);

  useEffect(() => {
    getMobileAppEvent();
  }, []);

  return (
    <div>
      {modalNewNotification && (
        <ModalNewNotification
          isOpen={modalNewNotification}
          toggle={toggleNewNotification}
          idEvent={idEvent}
          getAllNotification={getAllNotification}
        />
      )}

      {modalNewNotificationPublic && (
        <ModalNewNotificationPublic
          isOpen={modalNewNotificationPublic}
          toggle={toggleNewNotificationPublic}
          idEvent={idEvent}
          getAllNotificationPublic={getAllNotificationPublic}
        />
      )}

      {modalEditNotification && (
        <ModalEdidNotification
          isOpen={modalEditNotification}
          toggle={toggleEditNotification}
          editNotification={editNotification}
          idEvent={idEvent}
          getAllNotification={getAllNotification}
        />
      )}

      {modalRecipients && (
        <ModalNotificationRecipients
          isOpen={modalRecipients}
          toggle={() => setModalRecipients(false)}
          notification={selectedToRecipients}
        />
      )}

      {modalViewNotificationPrivate && (
        <ModalViewNotificationPrivate
          isOpen={modalViewNotificationPrivate}
          toggle={() => setModalViewNotificationPrivate(false)}
          data={selectedToView}
        />
      )}

      {modalAllImports && (
        <ModalAllImports
          isOpen={modalAllImports}
          toggle={() => setModalAllImports(false)}
          idEvent={idEvent}
          getData={getAllNotification}
          eventName={eventName}
        />
      )}

      {confirmAlert ? (
        <SweetAlert
          title={`Deseja deletar ${notificationDelete.title}`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete();
          }}
          onCancel={() => setConfirmAlert(false)}
        >
          Você não poderá reverter essa ação!
        </SweetAlert>
      ) : null}

      {successDlg ? (
        <SweetAlert
          success={!errorOnDelete}
          error={errorOnDelete}
          title={dynamicTitle}
          onConfirm={() => {
            getAllNotification();
            setSuccessDlg(false);
          }}
        >
          {dynamicDescription}
        </SweetAlert>
      ) : null}

      <Card>
        <CardBody>
          <CardTitle>
            {!isPublic
              ? "Notificações Push (Privadas)"
              : "Notificações Push (Públicas)"}
          </CardTitle>
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type={activeFilter === "date" ? "date" : "text"}
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type={activeFilter === "date" ? "date" : "text"}
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Row className="mobile-btns-top">
                <div
                  onClick={() => {
                    setIsPublic(!isPublic);
                  }}
                >
                  {isPublic ? "Filtrar: Privados" : "Filtrar: Públicos"}
                </div>
              </Row>
              <Collapse isOpen={isOpen}>
                <ActionButtonRounded
                  title="Criar Notificação Privada"
                  onClick={() => setModalNewNotification(true)}
                  type="mobile"
                />
                <ActionButtonRounded
                  title="Criar Notificação Pública"
                  onClick={() => setModalNewNotificationPublic(true)}
                  type="mobile"
                />
              </Collapse>
            </div>
            <div className="header-btns-container">
              <Button
                color="secondary"
                className="btn-rounded waves-effect waves-light events-button-add-lg"
                onClick={() => {
                  setIsPublic(!isPublic);
                }}
              >
                {isPublic ? "Filtrar: Privados" : "Filtrar: Públicos"}
              </Button>
              {isPublic ? (
                <ActionButtonRounded
                  title="Push Público"
                  onClick={() => {
                    setIsPublic(true);
                    setModalNewNotificationPublic(true);
                  }}
                  margin={"0 0 0 5px"}
                />
              ) : (
                <>
                  <ActionButtonRounded
                    title="Importar Pushs"
                    onClick={() => {
                      setModalAllImports(true);
                    }}
                    margin={"0 0 0 5px"}
                  />

                  <ActionButtonRounded
                    title="Push Privado"
                    onClick={() => {
                      setIsPublic(false);
                      setModalNewNotification(true);
                    }}
                    margin={"0 0 0 5px"}
                  />
                </>
              )}
            </div>
          </div>

          {!isPublic && (
            <div className="table-responsive">
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Título</th>
                    <th>Mensagem</th>
                    <th>Data do agendamento / envio</th>
                    <th>Todos Participantes</th>
                    <th>Aplicativos</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <LoadingSkelentonTable lines={10} cols={6} />
                  ) : (
                    notification.map((e) => (
                      <tr key={e.id}>
                        <th style={{ maxWidth: 200 }} scope="row">
                          {e.title}
                        </th>
                        <td style={{ maxWidth: 200 }}>{e.text}</td>
                        <td>{`${formatData(e.date)}  ${e.hour} `}</td>
                        <td>{e.allLogins ? "Sim" : "Não"}</td>
                        <td style={{ maxWidth: 200 }}>
                          {getAppNamePrivate(e.bundleId)}
                        </td>
                        <td>
                          <i
                            className="mdi mdi-pencil"
                            style={{
                              color: "green",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEditNotification(e);
                              setModalEditNotification(true);
                            }}
                          />
                          {""}
                          <i
                            className="mdi mdi-eye"
                            style={{
                              color: "blue",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedToView(e);
                              setModalViewNotificationPrivate(true);
                            }}
                          />
                          {""}
                          <i
                            className="mdi mdi-account-multiple"
                            style={{
                              color: "#556ee6",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            title="Destinatários"
                            onClick={() => {
                              setSelectedToRecipients(e);
                              setModalRecipients(true);
                            }}
                          />
                          {""}
                          {new Date(e.date) > new Date() && e.schedule ? (
                            <DeleteButton
                              onClick={() => {
                                if (new Date(e.date) > new Date()) {
                                  setNotificationDelete(e);
                                  setConfirmAlert(true);
                                }
                              }}
                            />
                          ) : (
                            <></>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}

          {isPublic && (
            <div className="table-responsive">
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Título</th>
                    <th>Mensagem</th>
                    <th>Data do envio</th>
                    <th>Aplicativo</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <LoadingSkelentonTable lines={10} cols={4} />
                  ) : (
                    notificationPublic.map((e) => (
                      <tr key={e.id}>
                        <th scope="row">{e.title}</th>
                        <td>{e.message}</td>
                        <td>{`${formatData(e.createdAt)}  ${formatHour(
                          e.createdAt,
                        )}`}</td>
                        <td>{getAppName(e.bundleId)}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </CardBody>
      </Card>
      <div className="bottom-navigation" style={{ justifyContent: "end" }}>
        <Pagination
          data={!isPublic ? notification : notificationPublic}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={!isPublic ? countData : countDataPublic}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Notification);
